import { AppMessageBar } from "@/components/AppMessageBar";
import { useVersionPermission } from "@/hooks/useCollectionPermission";
import { translation } from "@/i18n";
import { nsVersion } from "@/i18n/locales/version";
import { useWarningButtonStyles } from "@/styles";
import { Button } from "@fluentui/react-components";
import React from "react";

import { Version, checkIsRemovable } from "../../../domain/Version";
import { useDialogContextMenuItemsVersion } from "../../Dialog/DialogFirestore/DialogVersion/hooks";
import { useVersions } from "../../InOrganizationProvider/VersionsProvider";

const useTranslation = translation.use(nsVersion);

/**
 * @description 削除済みでも編集は塞がないため、削除済みであることを帯で知らせる。
 */
export const DeletedVersionBand: React.FC<{ version: Version }> = ({
  version,
}) => {
  const { t } = useTranslation();
  const buttonClasses = useWarningButtonStyles();
  const { versions } = useVersions();
  const [hasVersionWritePermission] = useVersionPermission("write");
  const [hasVersionDeletePermission] = useVersionPermission("delete");
  const {
    renderDialogsVersion,
    setSelectedVersionIds,
    handleRestoreVersions,
    setRemoveDialogPhaseType,
  } = useDialogContextMenuItemsVersion();

  const isDisableRemove =
    !hasVersionDeletePermission || !checkIsRemovable(version);

  return (
    <>
      <AppMessageBar
        intent="error"
        title={t.version.deletedBand.title()}
        actions={
          <>
            <Button
              appearance="transparent"
              style={{ minWidth: "auto" }}
              disabled={!hasVersionWritePermission}
              onClick={() => {
                setSelectedVersionIds([version.id]);
                handleRestoreVersions([version.id]);
              }}
            >
              {t.version.toolbar.restore()}
            </Button>
            <Button
              appearance="secondary"
              className={buttonClasses.warning}
              disabled={isDisableRemove}
              onClick={() => {
                setSelectedVersionIds([version.id]);
                setRemoveDialogPhaseType("confirm");
              }}
            >
              {t.version.toolbar.remove()}
            </Button>
          </>
        }
      >
        {t.version.deletedBand.message()}
      </AppMessageBar>
      {renderDialogsVersion(versions)}
    </>
  );
};
